export function replaceSpacesWithDashes(str) {
    return str.replace(' ', '-');
}
